<template>
  <div class="level-chart">

    <water-fill-chart2/>

    <div class="fee">
      <span class="level-show-span">سطح {{ $levels[state.userInfo.userAccountLevel]  }} کاربری</span>
      <div class="fee-text">
        <span class="txt-1">کارمزد</span>
        <span class="txt-2">{{state.userInfo.fee}} %</span>
      </div>
    </div>

    <div class="trade-value-next-level">
      <span class="next-level">حجم معاملات تا سطح بعدی</span>
      <span class="next-value">{{$toLocal(requiredTradeAmountToNextLevel)}} TMN</span>
    </div>

  </div>
</template>

<script>
import WaterFillChart2 from "./water-fill-chart2";

export default {
  name: "level-chart",
  components: {WaterFillChart2},
  data(){
    return{
      requiredTradeAmountToNextLevel:Number,
    }
  },
  methods:{
    calculateRequiredTradeAmountToNextLevel(){
let userLevels = this.state.userLevels

let userAccountLevel = this.state.userInfo.userAccountLevel

const customerUserLevel =  userLevels.find(item=>{
  return userAccountLevel == item.userAccountLevel
  

})

this.requiredTradeAmountToNextLevel = customerUserLevel.tradeAmount
    

    },
  },
  mounted(){
    this.calculateRequiredTradeAmountToNextLevel()
  },
  }

</script>

<style lang="scss" scoped>
.level-chart {
  display: flex;
  flex-direction: column;
  direction: rtl;

  .fee {
    display: flex;
    flex-direction: column;
    gap: 20px;

    .level-show-span {
      color: #FFFFFF;
      font-size: clamp(12px, 2vw, 16px);
    }
  }

  .fee-text {
    display: flex;
    flex-direction: row;
    gap: 5px;
    justify-content: center;
    align-items: center;

    .txt-1 {
      color: #FFFFFF;
      font-size: clamp(15px, 2vw, 18px);
    }

    .txt-2 {
      color: #04B3A2;
      font-size: clamp(15px, 2vw, 18px);
    }
  }

  .trade-value-next-level {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 50px;

    .next-level {
      font-size: 12px;
      color: rgba(215, 200, 200, 1);
    }

    .next-value {
      font-size: clamp(12px, 2vw, 16px);
      color: #FFFFFF;
    }
  }


}
</style>